import React, { useContext } from 'react';
import { useTheme } from '@mui/material/styles';
import { UiContext } from 'shared/lib/contexts/uiContext';
import cx from 'classnames';
import { defaultSpacingPresets } from 'shared/hooks/useGetSpacing';
import { IconProps } from 'shared/icons/iconProps';

export default function IconArrowLeft({
  extColor,
  isAutoscallable = true,
  sizeKey = '16x16',
  onClick,
  style,
}: IconProps) {
  const theme = useTheme();
  const fill = extColor || theme.palette.primary.main;
  const {
    spacings: {
      icons: { [sizeKey]: size },
    },
  } = useContext(UiContext);

  const w = isAutoscallable ? size.w : defaultSpacingPresets.icons[sizeKey].w;
  const h = isAutoscallable ? size.h : defaultSpacingPresets.icons[sizeKey].h;

  return (
    <svg
      className={cx('icon', { 'icon-disabled': !onClick })}
      onClick={onClick}
      style={style}
      width={w}
      height={h}
      viewBox="0 0 16 16"
      fill={fill}
    >
      <path d="M4.95086 8.828L9.65982 14.3353C9.74943 14.4404 9.8559 14.5239 9.97313 14.5808C10.0904 14.6377 10.216 14.667 10.343 14.667C10.4699 14.667 10.5956 14.6377 10.7128 14.5808C10.83 14.5239 10.9365 14.4404 11.0261 14.3353C11.2079 14.1207 11.3099 13.8309 11.3099 13.5288C11.3099 13.2267 11.2079 12.9369 11.0261 12.7223L7.9584 9.12195L7.61393 8.79978C7.61393 8.79978 7.19297 8.30018 7.19297 8.00032C7.19297 7.70047 7.61391 7.20087 7.61391 7.20087L7.9584 6.86074L11.0261 3.28803C11.1212 3.18466 11.1975 3.0599 11.2503 2.92123C11.3032 2.78256 11.3316 2.63283 11.3338 2.48102C11.3361 2.32921 11.3121 2.17843 11.2633 2.03773C11.2145 1.89703 11.1419 1.76929 11.0499 1.66218C10.9578 1.55508 10.8483 1.47079 10.7277 1.41439C10.6072 1.35798 10.4782 1.33061 10.3484 1.33393C10.2186 1.33724 10.0907 1.37116 9.97239 1.43366C9.85407 1.49615 9.74776 1.58595 9.65982 1.69765L4.95086 7.20746C4.76915 7.42361 4.66732 7.7146 4.66732 8.01773C4.66732 8.32085 4.76915 8.61185 4.95086 8.828Z" />
    </svg>
  );
}
